import './S_Alert.scss';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactElement } from 'react';

interface IProps {
  color: 'danger' | 'warning' | 'info' | 'success';
  className?: string;
  onClick?: () => void;
}

export const S_Alert = observer((props: PropsWithChildren<IProps>): ReactElement => {
  const { children, color, className, ...rest } = props;

  return (
    <div
      {...rest}
      className={classNames(className, color, 's-alert')}
    >
      {children}
    </div>
  );
});
